import { TripTypeEnum } from '../../enums/trip/trip-type.enum'
import { TripStepTypeEnum } from '../../enums/trip-bookings/trip-step-type.enum'
import { AffectedStaffBasic } from '../affectedStaff/affected-staff'
import type { CenterBasic } from '../center/center'
import { Trip } from '../trip/trip'
import { TripPlaceToCenterRequestBasic } from '../trip-place-to-center-request/trip-place-to-center-request'
import { TripBookingTypes } from './trip-booking'

export interface TripDate {
  id: number
  createdAt: Date
  updatedAt: Date

  isComplete: boolean

  // Can be only ONE WAY or RETURN
  directionality: TripStepTypeEnum
  date: Date

  trip: Trip
  tripId: number

  // # Places réservées jeunes
  numberOfStudentsPlacesReserved: number // Sum of reserved of the trip booking
  // # Places réservées encadrants
  numberOfStaffPlacesReserved: number // Sum of reserved of the trip booking
  // # Places demandées jeunes
  numberOfStudentsPlacesRequested: number // Sum of requested of the allocatedPlaces.tripPlaceToCenterRequest.numberOfStudentsPlacesRequested
  // # Places demandées encadrants
  numberOfStaffPlacesRequested: number // Sum of requested of the allocatedPlaces.tripPlaceToCenterRequest.numberOfStaffPlacesRequested

  // # Places dispatchées jeunes
  numberOfStudentsPlacesDispatched: number
  // # Places dispatchées encadrants
  numberOfStaffPlacesDispatched: number

  // # Places réparties jeunes
  numberOfStudentsPlacesAllocated: number
  // # Places réparties encadrants
  numberOfStaffPlacesAllocated: number

  // number of places remaining
  numberOfRemainingStudentPlaces: number
  numberOfRemainingStaffPlaces: number

  // # Places to dispatch
  numberOfStudentsPlacesToDispatch: number
  numberOfStaffPlacesToDispatch: number

  // # Places to allocate (requested - allocated)
  numberOfStudentsPlacesToAllocate: number
  numberOfStaffPlacesToAllocate: number

  tripBookings: TripBookingTypes.Partial[]
  tripPlacesRequests: TripPlaceToCenterRequestBasic[]
  dispatchedCenters?: Pick<CenterBasic, 'id' | 'name' | 'locked'>[]
}

export interface TripDateLight extends Pick<
  TripDate,
  | 'id'
  | 'date'
  | 'directionality'
  | 'trip'
  | 'tripPlacesRequests'
  | 'numberOfStudentsPlacesRequested'
  | 'numberOfStaffPlacesRequested'
  | 'numberOfStudentsPlacesAllocated'
  | 'numberOfStaffPlacesAllocated'
  | 'numberOfStudentsPlacesToAllocate'
  | 'numberOfStaffPlacesToAllocate'
> {}

export interface TripDateFilter {
  isCompleted?: boolean
  includesReservation?: boolean
  includesAllocations?: boolean
  isFullyDispatched?: boolean
  tripType?: TripTypeEnum

  date?: string | null
  tripIds?: number[]
  directionality?: TripStepTypeEnum

  numberOfPlacesReserved?: number[]
  numberOfPlacesRequested?: number[]
  reservationIds?: number[]
  lecResponsableId?: number
  remainingStudentPlaces?: boolean
  remainingStaffPlaces?: boolean
}

export enum TripBookingDispatchPlaceIndividualTypeEnum {
  ENROLLMENT = 'ENROLLMENT',
  AFFECTED_STAFF = 'AFFECTED_STAFF',
  MISSION_TO_STAFF = 'MISSION_TO_STAFF',
  MISSION_TO_EXTERNAL_STAFF = 'MISSION_TO_EXTERNAL_STAFF',
  MISSION_TO_LEC_STAFF = 'MISSION_TO_LEC_STAFF'
}

export type IndividualPlaceInput = {
  id: number
  type: TripBookingDispatchPlaceIndividualTypeEnum
}

/** key is the center id, value is the staff */
export type TripDateTripManagerMapping = Record<number, AffectedStaffBasic>
